import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';

import { Header, Loader } from '../../components';
import { db } from '../../utils/firebase-config';
import { Card, Container } from '../../components';

export const LandingPageContainer = ({ postList, getPostList, getPostDetail }) => {
    const [isloading, setIsloading] = useState(false);

    const getData = async () => {
        const titlesData = [];
        if (postList.length === 0) {
            setIsloading(true);
            const postQuery = query(collection(db, 'blog-data'), where('isDraft', '==', false));
            const querySnapshot = await getDocs(postQuery);
            querySnapshot.docs.forEach((blog) => {
                if (blog.data()) {
                    const titleUrl = blog.data()?.title.toLowerCase().replaceAll(' ', '-');
                    titlesData.push({ ...blog.data(), uuid: blog.id, id: titleUrl || blog.id });
                }
            });
            getPostList(titlesData);
            setIsloading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const RenderCard = () => postList.map((post, index) => (
        <Card
            key={index}
            post={post}
            getPostDetail={getPostDetail} />
    ));

    return (
        <>
            <Header />
            <Container>
                {isloading ? <Loader /> : <RenderCard />}
            </Container>
        </>
    );
};
